import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { RESEND_TASK } from './actionTypes';
import { resendTaskSuccessful, resendTaskFailed } from './actions';

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();


// Is user register successfull then direct plot user in redux.
function* resendTask(action) {

    try {
       yield call(tasksAPI.resendAPI, action.payload.token);
       yield put(resendTaskSuccessful(true));

    } catch (error) {
        console.log("errorCatch",error)
        yield put(resendTaskFailed(error));
    }
}

export function* watchResendTaskRegister() {
    yield takeEvery(RESEND_TASK, resendTask);
}

function* resendTaskSaga() {
    yield all([fork(watchResendTaskRegister)]);
}

export default resendTaskSaga;